import React, { useState } from "react";
import "./review.scss";
import { Select } from 'antd';
import moment from "moment";

import WidgetRating from "../../WidgetRating";
import { ReactComponent as StartBlue } from "../../../../../assets/svg/star-outline-blue.svg";

const { Option } = Select;
interface IWidgetReview {
  avgRating: string;
  review: []
}

export const Review: React.FC<IWidgetReview> = ({ avgRating, review }) => {
  // const [shownComments, setShownComments] = useState<any>({});
  const [filteredComments, setFilteredComments] = useState<any>(review);

  const handleChange = (value: any) => {
    const sortedAllRatings = [...review]
    if (value === "All Ratings") {
      return setFilteredComments(sortedAllRatings);
    }

    if (value === 1 || 2 || 3 || 4 || 5) {
      const filterRating = review.filter((revi: any) => Number(revi.rating) === value);
      setFilteredComments(filterRating)
    }

    if (value === "Most Recent") {
      setFilteredComments(review);
    }

    if (value === "Latest") {
      const sortedLatest = [...review]
      sortedLatest.sort((a: any, b: any) =>
        new Date(b.reviewed_at).getTime() - new Date(a.reviewed_at).getTime())
      setFilteredComments(sortedLatest)
    }

    if (value === "Old") {
      const sortedOld = [...review]
      sortedOld.sort((a: any, b: any) =>
        new Date(a.reviewed_at).getTime() - new Date(b.reviewed_at).getTime())
      setFilteredComments(sortedOld)
    }
  }

  // const toggleComment = (review_id: any) => {
  //   setShownComments((prevShownComments: any) => ({
  //     ...prevShownComments,
  //     [review_id]: !prevShownComments[review_id]
  //   }));
  // };

  return (
    <div className="review-container">
      <div className="top">
        <div className="ratings">
          <div className="ratings-title"> Average Ratings </div>
          <div className="rating-body">
            <div className="customer-rating">
              <WidgetRating avgRating={avgRating} height={20} />
              <div className="total-ratings">{review.length} ratings</div>
            </div>
            <div className="average-rating"> {avgRating}</div>
          </div>
        </div>
        <div className="review-filter">
          <Select defaultValue="All Ratings" style={{ width: 200 }} onChange={handleChange}>
            <Option value={5}><StartBlue height={20} fill="#007bff" /><StartBlue height={20} fill="#007bff" /><StartBlue height={20} fill="#007bff" /><StartBlue height={20} fill="#007bff" /><StartBlue height={20} fill="#007bff" /></Option>
            <Option value={4}><StartBlue height={20} fill="#007bff" /><StartBlue height={20} fill="#007bff" /><StartBlue height={20} fill="#007bff" /><StartBlue height={20} fill="#007bff" /></Option>
            <Option value={3}><StartBlue height={20} fill="#007bff" /><StartBlue height={20} fill="#007bff" /><StartBlue height={20} fill="#007bff" /></Option>
            <Option value={2}><StartBlue height={20} fill="#007bff" /><StartBlue height={20} fill="#007bff" /></Option>
            <Option value={1}><StartBlue height={20} fill="#007bff" /></Option>
            <Option value="All Ratings" className="ml-3">All Ratings</Option>
          </Select>
          <div className="vl"> </div>
          <Select defaultValue="All Reviews" style={{ width: 120 }} onChange={handleChange}>
            <Option value="all">All Reviews</Option>
          </Select>
          <div className="vl"> </div>
          <Select defaultValue="Most Recent" style={{ width: 120 }} onChange={handleChange}>
            <Option value="Most Recent">Most Recent</Option>
            <Option value="Latest">Latest to Old</Option>
            <Option value="Old">Old to Latest</Option>
          </Select>
        </div>
      </div>
      {filteredComments.map((reviewData: any, index: number) => {
        const { rating, review, reviewed_by, id, title, reviewed_at } = reviewData;
        const { first_name, last_name } = reviewed_by;
        return (
          <div className="bottom" key={index || id}>
            <div className="review-card">
              <div className="review">
                <div>
                  <div className="review-card-title">{title}</div>
                  <div className="review-card-subtitle">
                    {first_name[0].toUpperCase()}{first_name.substr(1)} {last_name} {moment(reviewed_at).format("MMM Do YYYY")}
                  </div>
                </div>
                <div className="review-card-rating">
                  <WidgetRating avgRating={rating} height={20} />
                </div>
              </div>
              <div className="review-card-body"> {review} </div>
              {/* <div className="review-card-footer">
                {id ? (
                  <button
                    onClick={() => toggleComment(id)}
                    className="reply-button"
                  >
                    {shownComments[id] ? "Cancel" : "Reply"}
                  </button>) : null}
              </div> */}
            </div>
            {/* {shownComments[id] ?
              <div className="reply-nested-comment">
                <textarea
                  onChange={(e) => e.target.value}
                  className="ant-input reply-textarea" />
                <button className="reply-button" >Reply</button>
              </div>
              : null} */}
            <hr />
          </div>
        );
      })}
    </div>
  );
};
